import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { APP_BRANDING } from '../config/branding.config';

/**
 * Pins the browser tab title to the product name on every navigation.
 * Overrides Angular's DefaultTitleStrategy (which pushes each route's
 * `title` and leaves a stale value on untitled routes). Route `title`
 * fields are intentionally ignored (left inert).
 */
@Injectable()
export class ConstantTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- override matches the TitleStrategy contract; the snapshot is intentionally ignored
  override updateTitle(_snapshot: RouterStateSnapshot): void {
    this.title.setTitle(APP_BRANDING.browserTitle);
  }
}
